import {getComponent} from "../jsbase/utils";
import $ from "jquery";
import JsBase from "../jsbase/jsbase";

$( document ).ready(function() {
    if ($('.my-positions-view').length === 1) {
        mypos.init();
    }
});

$(document).on('content-ready', function(ev, data) {
    if (data[0] && $(data[0]).is('#zpos-list')) {
        mypos.initTree();
    }
});

var mypos = {
    container: null,
    htmlEl: null,
    addPositionButton: null,
    drager: null,
    treeTable: null,
    dragOverTimeout: null,
    dragOverEl: null,

    init: function() {
        this.htmlEl = $('.main-page');
        this.container = $('#object');
        this.addPositionButton = this.htmlEl.find('[data-add-position]');
        this.addPositionButton.click(mypos.addRootPosition);
        project.container = this.container;
        project.addPositionButton = this.addPositionButton;

        this.listEl = getComponent(document.querySelector('#zpos-list'), 'filtered-list');
        this.listEl.load();

        $(project).on('positionopened', function(ev, options) {
            var nodes = project.container.find('[data-parent='+options.parent.attr('data-id')+']').not('.ghost');
            mypos.appendButtons(nodes);
        });
        $(project).on('before-positionreloaded', function(ev, options) {
            if (project.container.find(options.node.data('ttId')).length > 0) {
                mypos.treeTable.treetable("removeNode", options.node.data('ttId'));
            }
        });
        $(project).on('positionreloaded', function(ev, options) {
            var isRoot = (options.node.attr('data-parent') || "") === "";
            mypos.appendButtons(options.node.not('.ghost'), isRoot);

            if (options.node.is("[data-tt-id]")) {
                mypos.droppableSetup.apply(this);
            }
            var parentNodeId = options.node.attr('data-tt-parent-id');
            var parentNode = mypos.treeTable.treetable("node", parentNodeId) || null;

            mypos.treeTable.treetable("loadBranch", parentNode, options.node);
            // var nextNode = options.node.next();
            // if (nextNode.length === 1) {
            //     nextNode.before(options.node);
            // }
        });
    },

    initTree: function() {
        $(project).trigger('mypos-loaded', {});

        mypos.treeTable = $("#object table");
        mypos.treeTable.treetable({
            expandable: true,
            columnElType: 'td',
            column: 2,
            indent: 0,
            expanderTemplate: '<a class="linkify loader-indicator" href="#"><i class="fa bi-plus"></i><i class="fa bi-dash"></i><i class="fa bi-arrow-repeat fa-spin"></a>',
            onNodeCollapse: function() {
                var node = this;
                mypos.treeTable.treetable("unloadBranch", node);
                node.row.removeClass('opened');
            },
            onNodeExpand: function() {
                var node = this;
                if (node.row.is('.opened')) {
                    return;
                }
                node.row.addClass('expanding');
                project.openSubPositionsPart(node.row, function(rows) {
                    node.row.removeClass('expanding');
                    rows = rows.filter("[data-tt-id]");
                    rows.each(function() {
                        mypos.droppableSetup.apply(this);
                    });
                    mypos.treeTable.treetable("loadBranch", node, rows);
                });
            }
        });
        $(document).on("mouseenter", "#object [data-tt-id]", function() {
            var el = $(this);

            if(!el.data("dndInit")) {
                el.data("dndInit", true);

                el.draggable({
                    helper: function(el) {
                        return '<div class="bg-light p-1">Position verschieben</div>';
                    },
                    handle: ".drag-handle",
                    containment: '#template',
                    cursorAt: { left: -15 },
                    opacity: .75,
                    refreshPositions: true,
                    revert: "invalid",
                    revertDuration: 300,
                    scroll: true,
                    start: function() {
                        mypos.container.addClass('dragging');
                    },
                    stop: function(e, ui) {
                        mypos.container.removeClass('dragging');
                        var targetEl = mypos.dragOverEl;
                        if (!targetEl) return;

                        var droppedEl, node;
                        droppedEl = $(e.target);

                        if (!mypos.canMovePositionTo(droppedEl, targetEl)) {
                            return;
                        }

                        var sortList = {};
                        node = mypos.treeTable.treetable("node", droppedEl.data("ttId"));
                        var parentRow = mypos.treeTable.find('[data-id="'+targetEl.attr('data-tt-parent-id')+'"]');
                        var newParentId = $(parentRow).attr("data-tt-id");
                        var newDepth = parseInt(parentRow.attr('data-depth')) + 1;
                        var isBranch = targetEl.is('[data-tt-branch]');

                        debugger;
                        if (targetEl.is('.dndbefore') || targetEl.is('.dndafter')) {
                            if (targetEl.attr('data-tt-parent-id') !== droppedEl.attr('data-tt-parent-id')) {
                                mypos.treeTable.treetable("move", node.id, newParentId);
                                droppedEl
                                    .attr('data-depth', parseInt(parentRow.attr('data-depth')) + 1)
                                    .attr('data-tt-parent-id', newParentId)
                                    .attr('data-parent', newParentId);
                            }
                            if (targetEl.is('.dndbefore')) droppedEl.insertBefore(targetEl);
                            if (targetEl.is('.dndafter')) droppedEl.insertAfter(targetEl);
                            //
                            var siblings = [];
                            if (targetEl.attr('data-tt-parent-id')) {
                                siblings = mypos.treeTable.find('[data-tt-parent-id="' + targetEl.attr('data-tt-parent-id') + '"]');
                            } else {
                                siblings = mypos.treeTable.find('[data-depth="1"]');
                            }
                            $.each(siblings, function(i, el) {
                                sortList[$(el).attr('data-tt-id')] = i;
                            });
                            connection.getJson('/ProjectTree/MovePosition/' + node.id, {
                                type: 'post',
                                data: {
                                    sortList: sortList,
                                    parentId: newParentId,
                                },
                                onSuccess: function(data) {
                                },
                            });
                        } else if (targetEl.is('.dndactive') && isBranch) {
                            newParentId = targetEl.attr('data-tt-id');
                            newDepth = parseInt(targetEl.attr('data-depth')) + 1;

                            mypos.treeTable.treetable("move", node.id, $(this).data("ttId"));
                            droppedEl
                                .attr('data-depth', newDepth)
                                .attr('data-tt-parent-id', newParentId)
                                .attr('data-parent', newParentId);

                            $.each(mypos.treeTable.find('[data-tt-parent-id="' + newParentId + '"]'), function (i, el) {
                                sortList[$(el).attr('data-tt-id')] = i;
                            });
                            connection.getJson('/ProjectTree/MovePosition/' + node.id, {
                                type: 'post',
                                data: {
                                    sortList: sortList,
                                    parentId: newParentId,
                                },
                                onSuccess: function(data) {
                                },
                            });
                        }

                        mypos.treeTable.find('.dndactive').removeClass('dndactive');
                        mypos.treeTable.find('.dndbefore').removeClass('dndbefore');
                        mypos.treeTable.find('.dndafter').removeClass('dndafter');
                    },
                    drag: function(event, ui) {
                        if (mypos.dragOverEl != null) {
                            var sourceEl = $(event.target);
                            var targetEl = $(mypos.dragOverEl);

                            if (!mypos.canMovePositionTo(sourceEl, targetEl)) {
                                ui.helper.html('<span class="text-danger">Verschieben nicht möglich</span>');
                                return;
                            }
                            var isBranch = mypos.dragOverEl.is('[data-tt-branch]');
                            var threshholdBefore = isBranch ? 10 : 14;
                            var threshholdAfter = isBranch ? 20 : 14;
                            console.log(isBranch);
                            var newPosY = mypos.dragOverEl.offset().top - event.clientY;
                            mypos.treeTable.find('.dndbefore').removeClass('dndbefore');
                            mypos.treeTable.find('.dndafter').removeClass('dndafter');
                            if (Math.abs(newPosY) < threshholdBefore) {
                                mypos.dragOverEl.addClass('dndbefore');
                                ui.helper.html('Vor diese Position verschieben');
                            } else if (Math.abs(newPosY) > threshholdAfter) {
                                mypos.dragOverEl.addClass('dndafter');
                                ui.helper.html('Nach diese Position verschieben');
                            } else if (isBranch) {
                                ui.helper.html('Als Unterposition verschieben');
                            } else {
                                ui.helper.html('<span class="text-danger">Verschieben nicht möglich</span>');
                            }
                        }
                    },
                });
            }
        });

        mypos.treeTable.find("[data-tt-id]").each(function() {
            mypos.droppableSetup.apply(this);
        });

        project.registerInputs(mypos.container);
        mypos.appendButtons(mypos.container.find('tr[data-id]').not('.ghost'), true);
    },

    canMovePositionTo: function(sourceEl, targetEl) {
        var tmpPos = sourceEl;
        if (sourceEl.attr('data-id') == targetEl.attr('data-id')) {
            return false;
        }

        // search tree up
        while (tmpPos.is('[data-id]')) {
            if (tmpPos.attr('data-id') == targetEl.attr('data-id')) {
                return false;
            }
            tmpPos = mypos.treeTable.find(`[data-id="${tmpPos.attr('data-tt-parent-id')}"]`);
        }

        // search tree down
        tmpPos = sourceEl;
        while (tmpPos.is('[data-id]')) {
            if (tmpPos.attr('data-id') == targetEl.attr('data-id')) {
                return false;
            }
            tmpPos = mypos.treeTable.find(`[data-tt-parent-id="${tmpPos.attr('data-id')}"]`);
        }

        return true;
    },

    droppableSetup: function() {
        console.log($(this));
        $(this).droppable({
            accept: "[data-tt-id]",
            drop: function(e, ui) {
                if (mypos.dragOverTimeout) {
                    clearTimeout(mypos.dragOverTimeout);
                    mypos.dragOverTimeout = null;
                }
            },
            hoverClass: "accept",
            out: function() {
                if (mypos.dragOverTimeout) {
                    clearTimeout(mypos.dragOverTimeout);
                    mypos.dragOverTimeout = null;
                }
            },
            over: function(e, ui) {
                var node = this;
                var droppedEl = ui.draggable.closest("tr");
                mypos.dragOverEl = $(node);
                mypos.treeTable.find('.dndactive').removeClass('dndactive');
                mypos.dragOverEl.addClass('dndactive');

                if (mypos.dragOverEl.is('[data-tt-branch]')) {
                    if (mypos.dragOverTimeout) {
                        clearTimeout(mypos.dragOverTimeout);
                        mypos.dragOverTimeout = null;
                    }
                    mypos.dragOverTimeout = setTimeout(function () {
                        if (mypos.dragOverTimeout && node !== droppedEl[0] && !$(node).is(".expanded")) {
                            mypos.treeTable.treetable("expandNode", $(node).data("ttId"));
                        }
                    }, 500);
                }
            }
        });
    },

    appendButtons: function(nodes, isRoot) {
        var btnBar = nodes.find('.rel .btn-tools');
        $('<span class="position-delete btn btn-danger no-text"><svg class="bi" width="16" height="16" fill=""><use xlink:href="/files/images/bootstrap-icons.svg#trash"></use></svg></span>').prependTo(btnBar);
        $('<span class="position-add btn btn-light no-text" title="Unterposition erstellen"><svg class="bi" width="16" height="16" fill=""><use xlink:href="/files/images/bootstrap-icons.svg#plus-circle-fill"></use></svg></span>').prependTo(btnBar);
        if (isRoot) {
            $('<span class="position-options btn btn-light no-text"><i class="fa fa-fw bi-pencil-square"></i></span>').prependTo(btnBar);
        } else {
            $('<span class="btn btn-light no-text"><i class="fa fa-fw bi-pencil-square"></i></span>').prependTo(btnBar);
        }
        nodes.find('.position-add').off('click').on('click', mypos.addNewPosition);
        nodes.find('.position-options').off('click').on('click', mypos.openOptions);
        project.container.find('.position-delete').off('click').on('click', project.deletePosition);
    },

    addNewPosition: function(ev, buttonEl, asPricePosition, asBkp, asSumPosition) {
        buttonEl = buttonEl || $(this);
        var row = buttonEl.is('tr') ? buttonEl : $(buttonEl.parents('tr'));

        var url = '';
        if (asPricePosition === true) {
            url = this.htmlEl.find('.add-price-position[data-add-position]').attr('data-add-position');
        } else {
            url = this.htmlEl.find('.add-main-position[data-add-position]').attr('data-add-position');
        }
        slidein.openUrl(url + '&parentId=' + row.attr('data-id') + (asBkp ? '&createBkp=true' : '') + (asSumPosition ? '&createSumPosition=true' : ''));
        return false;
    },

    addRootPosition: function(ev) {
        slidein.openUrl($(ev.target).attr('data-add-position') + '&parentId=');
        return false;
    },

    openOptions: function() {
        var me = $(this);
        slidein.openUrl('/Project/PositionEditDetail/' + me.parents('tr').attr('data-id')+'?context=Template');
        return false;
    },

    reloadPosition: function() {
        var me = $(this);
        project.reloadPosition(me.parents('tr[data-id]'));
        return false;
    }

};
window.mypos = mypos;
